import axios from 'axios'
import {Message, Loading} from 'element-ui'

let baseURL
// 判断开发环境（一般用于本地代理）
if (process.env.NODE_ENV === 'development') {      // 开发环境
  baseURL = window.APIURL.devUrlApi
} else {                                           // 生产环境
  baseURL = window.APIURL.prodUrlApi
}
/******* 创建文件上传axios实例 **********/
const uploadService = axios.create({
  baseURL: baseURL,
  timeout: 30000 //文件上传请求时间

});

let loading;        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '上传中……',
    background: 'rgba(0, 0, 0, 0.3)'
  })
}

function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

/*********request拦截器==>对请求参数做处理**********/
uploadService.interceptors.request.use(config => {
  //打开预加载
  if (config.showLoading) {
    showFullScreenLoading();
  }
  config.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8'
  config.headers['Authorization'] = JSON.parse(LocalStorage.getItem('obj')) ? JSON.parse(LocalStorage.getItem('obj')).authToken : '';
  //params没有vdnId的话统一添加
  if(LocalStorage.getItem('obj') && JSON.parse(LocalStorage.getItem('obj')).vdnId && (!config.params || !config.params.vdnId)){
    config.url = config.url + '?vdnId=' + JSON.parse(LocalStorage.getItem('obj')).vdnId
  }
  return config
}, error => {
  Message({
    message: error,
    type: 'error'
  })
  Promise.reject(error)
})

/****** respone拦截器==>对响应做处理 ******/
uploadService.interceptors.response.use(
  response => {
    //关闭预加载
    if (response.config.showLoading) {
      tryHideFullScreenLoading();
    }
    if (response.status === 200) {
      //排除不需要提示的情况
      if(response.data.retCode !== 1){
        Message({
          message: response.data.retMsg,
          type: 'error'
        });
      }
      
      //下列状态退回登录页面
      if (response.data.retCode === 105 || response.data.retCode === 106 || response.data.retCode === 109 || response.data.retCode === 102 || response.data.retCode === 5 || response.data.retCode === 114) {
        console.log(response.data.retMsg)
        if (LocalStorage.getItem("obj")) {
          LocalStorage.removeItem('obj');
          LocalStorage.removeItem('getPublicKey');
        }
        console.log('上传状态码' + response.data.retCode + '触发退出......')
        router.push('/');
      }
      
      return response.data
    } else {
      Message({
        message: response.statusText,
        type: 'error'
      })
    }
  },
  error => {  //响应错误处理
    console.log('error')
    console.log(error)
    console.log(JSON.stringify(error))

    let text = JSON.parse(JSON.stringify(error)).response.status === 404 ? '404' : '网络异常，请重试'
    Message({
      message: text,
      type: 'warning'
    })
    try {
      //关闭预加载
      if (error.config.showLoading) {
        tryHideFullScreenLoading();
      }
      return Promise.reject(error)
    } catch (err) {

    }

    return Promise.reject(error)
  }
);

export default uploadService;



// WEBPACK FOOTER //
// ./src/http/uploadRequest.js